<script lang="ts">
/*
Edit User screen-
To change name, delete user (+ all info)
Maybe int he future change user icon?
*/

import CategoryData from '@/ts/DataTypes/CategoryData';
import Data from '@/ts/Data';
import { defineComponent, nextTick } from 'vue'
import Category from './Category.vue';

import StaticVars from '@/ts/StaticVars';
import Entry, { EntryDB } from '@/ts/DataTypes/Entry';
import { db, UserDB} from '../ts/DexieDB';
import InputTextSmartVue from './InputTextSmart.vue';
import ButtonVue from './Button.vue';
import EntryEditable from './EntryEditable.vue';

export default defineComponent({
    components: { InputTextSmartVue, ButtonVue, EntryEditable },
    props: {
        //have to have this as a variable in the router/index.ts to actually get it: /:category
        //and can't share data- only strings between components if using vue router
        SwitchScreen: { type: Function, default: () => { console.log("it didn't pass func correctly"); } },
        ReloadPage: { type: Function, default: () => { console.log("it didn't pass func correctly"); } },
        category: { type: String },
        extra: { type: Object, default: {} },
        // user:{type:UserDB, required:true},
        ShowModal:{ type:Function, default:()=>{console.log("it didn't pass ShowModal correctly");}},//have to give it a default value, or typescript thinks it could be undefined...,


    },
    data() 
    {
        return {
          entry:(new Entry({blank:true})),
          extra_info:({}),
          loaded:false,
          user:({} as UserDB),

        };
    },
    mounted() 
    {
        console.log("user edit screen mounted ! extra:", this.extra);
        this.user = (this.extra as any).user ;
        console.log("user edit screen mounted ! user:", this.user);
       this.loaded=true;
    },
    computed: 
    {
       
    },
    methods: 
    {
        Back()
        {
            this.SwitchScreen(StaticVars.SCREENS.HOME);
        },
        async ChangeUserName()
        {
            let name = (this.$refs.user_name as HTMLInputElement).value;
            if(!name)
                this.ShowModal({text: `The user name must not be blank`, only_one_btn:true});
            else
            {
                (this.user as any).name = name;
                let user_updated = new UserDB(this.user)
                console.log("updating user to: ", user_updated)
                await Data.UpdateUser(user_updated);
                

                this.ShowModal({text: `User name changed to ${this.user.name}`, callback_yes: this.Back, only_one_btn:true});
            }
        },
        DeleteUser()
        {
            this.ShowModal({text: `Delete User ${this.user.name} and all data for good? `, callback_yes: this.DeleteUserForReal});

        },
        async DeleteUserForReal()
        {
            console.log("deleting user for real", this.user);
            console.log("need to actually delete user and all related data");
            await Data.DeleteUser(this.user);
            await nextTick()
            await nextTick()
            this.ShowModal({text: `User ${this.user.name} and all their associated data deleted. Reloading app...`, callback_yes: this.ReloadPage, only_one_btn:true});
            //need to also reload the app
        },
        
    },
    
});
</script>

<template>

    <div class="container" v-if="loaded">
        <input type="text" :value="user.name" placeholder="Enter UserName" ref="user_name"/>
        <ButtonVue text="Change User Name" type="yes" :callback="ChangeUserName"/>
        <ButtonVue text="Delete User" type="no" :callback="DeleteUser"/>

        
        

    </div>
    <ButtonVue text="" class="back" type="back" :callback="Back"/>
</template>

<style scoped>
.container
{
    display: flex;
    width:100%;
    gap:10px;
    flex-direction: column;
    margin-top:10px;
    /* align-content: flex-start; */
    position: relative;

    /* For bottom button*/
    height: calc(-65px + 100vh);
    overflow-y: auto;
    scrollbar-width: thin;
}
.back
{
    display:block;
    /* Hack- for some reason setting to 100% with padding causes it to be 100% + padding */
    width:calc(100% - 20px);
}

</style>